<template>
  <div>
    <Header v-if="isAdmin" />
    <Table />
  </div>
</template>

<script>
import Header from "./Toolbar";
import Table from "./Table.vue";
export default {
  components: {
    Header,
    Table
  }
};
</script>

<style></style>
